export const server = "https://console.authkey.io";